if (!customElements.get('swatch-media-gallery')) {
    customElements.define('swatch-media-gallery', class SwatchMediaGallery extends HTMLElement {
      constructor() {
        super();

        this.sliders = [];
        this.carousels = [];
        this.pairs = [];
        this.buildLayout();
        this.checkVisibility();
        $(this).find('> div').show();
      }

      buildLayout() {
        var that = this
        // main slider
        $('[data-slider]').each(function(index, item) {
            var swatchKey = $(item).data('slider');
            if (!that.sliders[swatchKey]) {
                that.sliders[swatchKey] = [];
            }
            $(this).addClass('slider__item');
            that.sliders[swatchKey].push(item);
        });
        for (var swatchKey in that.sliders) {
            $(that.sliders[swatchKey]).wrapAll('<swatch-media-slider class="slider" data-gallery="'+swatchKey+'"></swatch-media-slider>')
            if (!that.pairs[swatchKey]) {
                that.pairs[swatchKey] = []
            }
        }
        // carousel
        $('[data-carousel]').each(function(index, item) {
            var swatchKey = $(item).data('carousel');
            if (!that.carousels[swatchKey]) {
                that.carousels[swatchKey] = [];
            }
            $(this).addClass('carousel__item');
            that.carousels[swatchKey].push(item);
        });
        for (var swatchKey in that.sliders) {
            $(that.carousels[swatchKey]).wrapAll('<swatch-media-carousel class="carousel" data-gallery="'+swatchKey+'"></swatch-media-carousel>')
            if (!that.pairs[swatchKey]) {
                that.pairs[swatchKey] = []
            }
        }
        // group both
        for (var swatchKey in that.pairs) {
            $('[data-gallery="'+swatchKey+'"]').wrapAll('<swatch-media-gallery-item id="gallery-'+swatchKey+'"><div class="swatch-media-gallery__inner"></div></swatch-media-gallery-item>');
        }
      }

      checkVisibility() {
        $(this).on('change', function(e) {
            $('swatch-media-gallery-item', this).hide();
            var $activeGallery = $('swatch-media-gallery-item#gallery-'+e.detail.swatch, this)
            $activeGallery.show();
            $activeGallery.get(0).refresh();
        })

        var currentSwatch = $(this).data('current-swatch');
        currentSwatch = currentSwatch.replaceAll(' ', '_');

        var currentEl = $('swatch-media-gallery-item#gallery-'+currentSwatch, this);
        currentEl.show();
        $('swatch-media-gallery-item', this).not(currentEl).hide();
      }
    });
}


if (!customElements.get('swatch-media-gallery-item')) {
    customElements.define('swatch-media-gallery-item', class SwatchMediaGalleryItem extends HTMLElement {
      constructor() {
        super();
      }

      refresh() {
        $('swatch-media-slider', this).get(0).refresh();
        $('swatch-media-carousel', this).get(0).refresh();
      }
    });
}

if (!customElements.get('swatch-media-slider')) {
    customElements.define('swatch-media-slider', class SwatchMediaGallery extends HTMLElement {
      constructor() {
        super();
        var that = this;
        var totalSlide = $('.slider__item', this).length;

        $(this).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            cssEase: 'linear',
        });

        var slideIndex = $(this).slick('slickCurrentSlide') + 1;
        $(this).after('<div class="slider__status"><span class="slider__index">'+slideIndex+'</span> / <span class="slider__total">'+totalSlide+'</span></div>');

        $(this).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            $('.slider__index', $(that).parent()).text(nextSlide + 1);
        });
      }

      refresh() {
        $(this).slick('setPosition');
      }
    });
}

if (!customElements.get('swatch-media-carousel')) {
    customElements.define('swatch-media-carousel', class SwatchMediaCarousel extends HTMLElement {
      constructor() {
        super();

        $(this).slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            asNavFor: $(this).parent().find('swatch-media-slider'),
            focusOnSelect: true,
            arrows: false
        })
      }

      refresh() {
        // $(this).slick('setPosition');

        $(this).slick('unslick'); /* ONLY remove the classes and handlers added on initialize */
        $(this).slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            asNavFor: $(this).parent().find('swatch-media-slider'),
            focusOnSelect: true,
            arrows: false
        }); /* Initialize the slick again */

      }
    });
}